<template>
  <div>
    <el-row class="websitequerypanel">
      <el-col :span="12">
        <el-form ref="form"  label-width="100px" label-position="left">
          <el-form-item label="专题选择:">
            <el-select v-model="zttypeinfo" filterable placeholder="请选择专题" @change="ztchange">
              <el-option
                v-for="item in zttypelist"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="24">
        <div>
          <el-button style="margin-top: 10px" @click="addnewzt">增加新专题</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row class="querypanel">
      <el-table
        stripe
        :data="pagecontextdata"
        ref="multipleTable">
        <el-table-column
          prop="title.String"
          width = "100px"
          label="标题名称">
        </el-table-column>
        <el-table-column
          label="资源地址">
          <template slot-scope="scope">
            <div v-if="scope.row.ossurl.Valid">
              {{scope.row.ossurl.String}}
            </div>
            <div v-else>
              {{scope.row.resourceoss.String}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="link.String"
          label="页面链接">
        </el-table-column>
        <el-table-column
          label="操作"
          width="120px"
        >
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="填充子页面内容" placement="top-start">
              <i class="fa fa-pencil-square-o opicon curpointer" v-on:click="addsubzt(scope.$index, pagecontextdata)"></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="修改资源图片" placement="top-start">
              <i class="fa fa-pencil-square-o opicon curpointer" v-on:click="edittp(scope.$index, pagecontextdata)"></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="移除该资源" placement="top-start">
              <i class="fa fa-trash-o opicon fa-lg curpointer" v-on:click="removezt(scope.$index, pagecontextdata)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-dialog :title="addzttitle" :visible.sync="dialogztVisible">
      <div class="showpcinfo">
        <el-form :model="form" label-width="150px">
          <el-form-item label="名称">
            <el-input  v-model="zttitle" placeholder="请输入标题"></el-input>
          </el-form-item>
          <el-form-item label="封面上传">
            <el-input  v-model="ztimg" placeholder="请在下方选择对应图片"></el-input>
          </el-form-item>
          <el-row class="querypanel" style="color:#000">
            <el-col :span="12">
              <div class="leftpanel">
                <div>Oss路径:</div>
                <el-tree
                  ref="oldtree"
                  class="filter-tree"
                  :props="pathprops"
                  default-expand-all
                  @node-click="pathselect"
                  :expand-on-click-node="false">
                </el-tree>
                <div class="desinfo"> *定义不同的路径等级与路径和客户</div>
              </div>
            </el-col>
            <el-col :span="8" style="margin-left: 10px;">
              <div>当前路径ID: {{ selectpath }}</div>
              <el-form  label-width="120px" style="margin-top: 20px;">
                <el-form-item label="示意图" class="yyzz_upload">
                  <img class="bigavatarimg" :src="ztimg" />
                </el-form-item>
              </el-form>
              <el-form  label-width="120px" style="margin-top: 20px;">
                <el-form-item label="上传资料" class="yyzz_upload">
                  <el-upload
                    class="avatar-uploader"
                    drag
                    action=""
                    :on-success="fnUploadSuccess"
                    :headers="uploadHeaders"
                    :show-file-list="true"
                    :http-request="fnUploadRequest"
                    :limit="files">
                  </el-upload>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <el-row class="querypanel">
            <el-col :spen="12">
              <el-button @click="save_ztcontext">保存修改</el-button>
              <el-button @click="addztimg">添加图片</el-button>
              <el-button @click="addztvideo">添加视频</el-button>
              <el-button @click="addztvideoimg">添加视频封面</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog :title="addsubzttitle" :visible.sync="dialogsubztVisible">
      <div class="showpcinfo">
        <el-form :model="form" label-width="150px">
          <el-form-item label="名称">
            <el-input  v-model="zttitle" placeholder="请输入标题"></el-input>
          </el-form-item>
          <el-form-item label="所选资料">
            <el-input  v-model="ztimg" placeholder="请在下方选择对应图片"></el-input>
          </el-form-item>
          <el-row class="querypanel">
            <el-col :spen="12">
              <el-button @click="save_ztcontext">保存修改</el-button>
              <el-button @click="addztimg" :hidden="ifhidden">添加图片</el-button>
              <el-button @click="addztvideo" :hidden="ifhidden">添加视频</el-button>
              <el-button @click="addztvideoimg" :hidden="ifhidden">添加视频封面</el-button>
            </el-col>
          </el-row>
          <el-row :hidden="ifhidden">
            <el-col :span="12">
              <el-form-item label="图片资料">
              </el-form-item>
              <el-table
                stripe
                :data="pageimgdata"
                ref="multipleTable">
                <el-table-column
                  label="资源地址">
                  <template slot-scope="scope">
                    <div v-if="scope.row.ossurl.Valid">
                      {{scope.row.ossurl.String}}
                    </div>
                    <div v-else>
                      {{scope.row.resourceoss.String}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="120px"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="移除该资源" placement="top-start">
                      <i class="fa fa-trash-o opicon fa-lg curpointer" v-on:click="removeimg(scope.$index, pageimgdata)"></i>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
            <el-col :span="12">
              <el-form-item label="视频资料">
              </el-form-item>
              <el-table
                stripe
                :data="pagemoviedata"
                ref="multipleTable">
                <el-table-column
                  label="资源地址">
                  <template slot-scope="scope">
                    <div v-if="scope.row.ossurl.Valid">
                      {{scope.row.ossurl.String}}
                    </div>
                    <div v-else>
                      {{scope.row.resourceoss.String}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="120px"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="移除该资源" placement="top-start">
                      <i class="fa fa-trash-o opicon fa-lg curpointer" v-on:click="removemovie(scope.$index, pagemoviedata)"></i>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
          <el-row class="querypanel" style="color:#000">
            <el-col :span="11">
              <div class="leftpanel">
                <div>Oss路径:</div>
                <el-tree
                  class="filter-tree"
                  ref="newdata"
                  :data="newpathdata"
                  :props="pathprops"
                  default-expand-all
                  @node-click="newpathselect"
                  :expand-on-click-node="false">
                </el-tree>
                <div class="desinfo"> *定义不同的路径等级与路径和客户</div>
              </div>
            </el-col>
            <el-col :span="12" style="margin-left: 10px;">
              <div>当前路径ID: {{ selectpath }}</div>
              <el-form  label-width="120px" style="margin-top: 20px;">
                <el-form-item label="示意图" class="yyzz_upload">
                  <img class="bigavatarimg" :src="ztimg" />
                </el-form-item>
              </el-form>
              <el-form  label-width="120px" style="margin-top: 20px;">
                <el-form-item label="上传资料" class="yyzz_upload">
                  <el-upload
                    class="avatar-uploader"
                    drag
                    multiple
                    action=""
                    :on-success="fnUploadSuccess"
                    :headers="uploadHeaders"
                    :show-file-list="true"
                    :http-request="fnUploadRequest"
                    :limit="files">
                  </el-upload>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import Utils from '../../util/utils'
import '../../../static/css/my.css'
var OSS = require('ali-oss')
Vue.prototype.$http = axios
var that
export default {
  name: 'PageContext',
  data () {
    return {
      zttypelist: [{
        value: '1',
        label: '艺人'
      }, {
        value: '2',
        label: '创作'
      }, {
        value: '3',
        label: '商业'
      }],
      zttypeinfo: '',
      khid: '',
      pagecontextdata: [],
      pageimgdata: [],
      pagemoviedata: [],
      dialogztVisible: false,
      dialogsubztVisible: false,
      pageinfo: '',
      modelinfo: '',
      s_url: '',
      pagelist: [],
      newpathdata: [],
      pathdata: [],
      selectcontext: '',
      modellist: [],
      colinfo: '',
      rowinfo: '',
      tximgurlok: false,
      s_title: '',
      s_ossurl: '',
      selectpathid: '',
      resourcename: '',
      selecteditpathid: '',
      selectresourcedata: '',
      ossresourcedata: [],
      selectsubdata: [],
      selectuppath: '',
      addzttitle: '',
      addsubzttitle: '',
      pathprops: {
        children: 'Children',
        label: 'path'
      },
      rowlist: [],
      collist: [ {
        value: '4',
        label: '图片'
      }, {
        value: '5',
        label: '视频'
      }],
      ifhidden: false,
      bucketname: 'wyzb1',
      selectpathdata: '',
      selectpathnode: '',
      selectpathdata1: '',
      selectpathnode1: '',
      selectuppathtitle: '',
      selectpath: '',
      ztimg: '',
      zttitle: '',
      ifeditzt: false
    }
  },
  mounted: function () {
    var v = getCookie('cusid')
    this.khid = v
    that = this
    if (that.khid === null) {
      that.$message({
        type: 'info',
        message: 'Cookie已失效，请重新登录!'
      })
      that.$router.push({path: '/'})
    } else {
      var qstr = 'id> 0'
      that.$http({
        url: 'https://api.sqnetsoft.cn/website/qpi',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.pagelist = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })

      that.$http({
        url: 'https://api.sqnetsoft.cn/website/qcm',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.modellist = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })

      that.$http({
        url: 'https://api.sqnetsoft.cn/oss/listpath',
        method: 'post',
        data: {
          bucketname: that.bucketname,
          bucketpath: {String: 'images/', Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            var treedatas = []
            var treedatas1 = []
            var arrdatas = JSON.parse(res.data.data)
            for (var i = 0; i < arrdatas.length; i++) {
              console.log(arrdatas[i])
              var treedata
              treedata = {
                path: arrdatas[i],
                Children: []
              }
              treedatas.push(treedata)
              treedatas1.push(treedata)
            }
            that.pathdata = treedatas
            that.newpathdata = treedatas1
            console.log(JSON.parse(res.data.data))
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    }
  },
  methods: {
    pathselect (data, node) {
      console.log(this)
      console.log(this.$refs.olddata)
      console.log(this.$refs.newdata)
      console.log(data.path)
      this.selectpathdata = data
      this.selectpathnode = node
      that.selectuppathtitle = '上传资料到路径：' + data.path
      this.selectpath = data.path
      this.ztimg = 'https://' + this.bucketname + '.oss-cn-beijing.aliyuncs.com/' + data.path
      that.$http({
        url: 'https://api.sqnetsoft.cn/oss/listpath',
        method: 'post',
        data: {
          bucketname: this.bucketname,
          bucketpath: {String: data.path, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            var treedatas = []
            var arrdatas = JSON.parse(res.data.data)
            for (var i = 0; i < arrdatas.length; i++) {
              console.log(arrdatas[i])
              if (data.path !== arrdatas[i]) {
                var treedata
                treedata = {
                  path: arrdatas[i],
                  Children: []
                }
                treedatas.push(treedata)
              }
            }
            data.Children = treedatas
            node.expanded = true
            console.log('当前数据')
            console.log(data)
            that.pathdata = node.store.data
            console.log(node)
            console.log(JSON.parse(res.data.data))
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    newpathselect (data, node) {
      console.log(this)
      console.log(this.$refs.olddata)
      console.log(this.$refs.newdata)
      this.selectpathdata = data
      this.selectpathnode = node
      that.selectuppathtitle = '上传资料到路径：' + data.path
      this.selectpath = data.path
      this.ztimg = 'https://' + this.bucketname + '.oss-cn-beijing.aliyuncs.com/' + data.path
      that.$http({
        url: 'https://api.sqnetsoft.cn/oss/listpath',
        method: 'post',
        data: {
          bucketname: this.bucketname,
          bucketpath: {String: data.path, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            var treedatas = []
            var arrdatas = JSON.parse(res.data.data)
            for (var i = 0; i < arrdatas.length; i++) {
              console.log(arrdatas[i])
              if (data.path !== arrdatas[i]) {
                var treedata
                treedata = {
                  path: arrdatas[i],
                  Children: []
                }
                treedatas.push(treedata)
              }
            }
            data.Children = treedatas
            node.expanded = true
            console.log('当前数据')
            console.log(data)
            that.newpathdata = node.store.data
            console.log(node)
          }
        })
    },
    pathcontext (h, { node, data, store }) {
      return (
        <span style="flex: 1; display: flex; align-items: center; justify-content: space-between; font-size: 14px; padding-right: 8px;">
          <span>
            <span>{data.path}</span>
          </span>
          <span>
            <i class="fa fa-pencil-square-o opicon" on-click={ () => this.path_edit(node, data)}> </i>
          </span>
        </span>
      )
    },
    path_edit (node, data) {
      console.log(data)
      this.selecteditpathid = data.id
      this.cursourceid = data.id
      if (node.level === 1) {
        this.selectuppath = data.path
      } else if (node.level === 2) {
        this.selectuppath = node.parent.data.path + '/' + node.data.path
      } else if (node.level === 3) {
        this.selectuppath = node.parent.parent.data.path + '/' + node.parent.data.path + '/' + node.data.path
      } else if (node.level === 3) {
        this.selectuppath = node.parent.parent.parent.data.path + '/' + node.parent.parent.data.path + '/' + node.parent.data.path + '/' + node.data.path
      }
      var qstr
      if (that.resourcename === '' || that.resourcename === null || that.resourcename === '0') {
        qstr = 'pathid =' + this.selecteditpathid
      } else if (that.resourcename === '2') {
        qstr = 'pathid =' + this.selecteditpathid + ' and (rtypeid = 1 or rtypeid = 2)'
      } else {
        qstr = 'pathid =' + this.selecteditpathid + ' and rtypeid = ' + that.resourcename
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/website/qor',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true},
          sorinfo: {String: 'order by LENGTH(ossurl), ossurl', Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.ossresourcedata = JSON.parse(res.data.data)
            that.selectsubdata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    ztchange (value) {
      var pageinfotmp = 0
      switch (value) {
        case '1': {
          pageinfotmp = 2
          break
        }
        case '2': {
          pageinfotmp = 4
          break
        }
        case '3': {
          pageinfotmp = 6
          break
        }
      }
      this.pageinfo = pageinfotmp
      var qstr = 'pageid = ' + pageinfotmp + ' and modelid = 3'
      that.$http({
        url: 'https://api.sqnetsoft.cn/website/qmc',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.pagecontextdata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    pagechange (value) {
      this.pageinfo = value
      var qstr = 'cusid = 19 and pageid = ' + this.pageinfo + ' and modelid = ' + this.modelinfo
      that.$http({
        url: 'https://api.sqnetsoft.cn/website/qmc',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.pagecontextdata = JSON.parse(res.data.data)
            that.rowlist = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    resourcetypechange (value) {
      this.modelinfo = value
      var qstr = 'cusid = 19 and pageid = ' + this.pageinfo + ' and modelid = ' + this.modelinfo
      that.$http({
        url: 'https://api.sqnetsoft.cn/website/qmc',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.pagecontextdata = JSON.parse(res.data.data)
            that.rowlist = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    rowchange () {
      var pageno = this.pageinfo + 1
      var qstr = 'cusid = 19 and pageid = ' + pageno + ' and rowindex =' + this.rowinfo
      that.$http({
        url: 'https://api.sqnetsoft.cn/website/qmc',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.pagecontextdata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    colchange () {
      var pageno = this.pageinfo + 1
      var qstr = 'cusid = 19 and pageid = ' + pageno + ' and rowindex =' + this.rowinfo + ' and modelid =' + this.colinfo
      that.$http({
        url: 'https://api.sqnetsoft.cn/website/qmc',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.pagecontextdata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    edittp (index, data) {
      this.ifhidden = true
      console.log(data[index])
      this.ifeditzt = true
      this.selectcontext = data[index]
      this.dialogsubztVisible = true
      switch (this.pageinfo) {
        case 2: {
          this.addsubzttitle = '添加新艺人作品'
          break
        }
        case 4: {
          this.addsubzttitle = '添加新创作作品'
          break
        }
        case 6: {
          this.addsubzttitle = '添加新商业作品'
          break
        }
      }
      this.zttitle = this.selectcontext.title.String
      if (this.selectcontext.ossurl.Valid) {
        this.ztimg = this.selectcontext.ossurl.String
      } else {
        this.ztimg = this.selectcontext.resourceoss.String
      }
    },
    removeresource (index, data) {
      console.log(data[index])
      var idstr = 'id =' + data[index].id.Int64
      console.log(idstr)
      that.$http({
        url: 'https://api.sqnetsoft.cn/website/dmc',
        method: 'post',
        data: {
          whereinfo: {String: idstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            if (res.data.success) {
              var pageno = that.pageinfo + 1
              var qstr = 'cusid = 19 and pageid = ' + pageno + ' and rowindex =' + that.rowinfo
              that.$http({
                url: 'https://api.sqnetsoft.cn/website/qmc',
                method: 'post',
                data: {
                  whereinfo: {String: qstr, Valid: true}
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  if (res.data.success) {
                    console.log(JSON.parse(res.data.data))
                    that.pagecontextdata = JSON.parse(res.data.data)
                    that.$message({
                      type: 'success',
                      message: '删除成功!'
                    })
                  }
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
            }
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    pathchange (value) {
      console.log(value)
      this.selectpathid = value
      var qdata = {
        id: {Int64: parseInt(this.selectpathid), Valid: true},
        cusid: 19
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/website/gorpt',
        method: 'post',
        data: qdata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.pathdata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    myresourcetypechange (value) {
      console.log(value)
      that.resourcename = value
      var qstr
      if (that.resourcename === '' || that.resourcename === null || that.resourcename === '0') {
        qstr = 'pathid =' + this.selecteditpathid
      } else if (that.resourcename === '2') {
        qstr = 'pathid =' + this.selecteditpathid + ' and (rtypeid = 1 or rtypeid = 2)'
      } else {
        qstr = 'pathid =' + this.selecteditpathid + ' and rtypeid = ' + that.resourcename
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/website/qor',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true},
          sorinfo: {String: 'order by LENGTH(ossurl), ossurl', Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.ossresourcedata = JSON.parse(res.data.data)
            that.selectsubdata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    selectresource (index, data) {
      console.log(data[index])
      this.selectresourcedata = data[index]
      this.s_ossurl = this.selectresourcedata.ossurl.String
    },
    save_pagecontext () {
      console.log(this.selectcontext)
      console.log(this.selectresourcedata)
      var idtmp, typetmp
      if (this.selectresourcedata) {
        idtmp = this.selectresourcedata.id.Int64
        typetmp = this.selectresourcedata.rtypeid
      } else {
        idtmp = this.selectcontext.resourceid
        typetmp = this.selectcontext.resourcetype
      }
      var updata = {
        id: {Int64: parseInt(this.selectcontext.id.Int64), Valid: true},
        pageid: parseInt(this.selectcontext.pageid),
        modelid: parseInt(this.selectcontext.modelid),
        rowindex: parseInt(this.selectcontext.rowindex),
        colindex: parseInt(this.selectcontext.colindex),
        resourcetype: parseInt(typetmp),
        resourceid: parseInt(idtmp),
        resourcename: {String: this.selectcontext.resourcename.String, Valid: true},
        resourcecontext: {String: this.selectcontext.resourcecontext.String, Valid: true},
        curdate: {String: this.selectcontext.curdate.String, Valid: true},
        datefontname: {String: this.selectcontext.datefontname.String, Valid: true},
        datefontsize: {String: this.selectcontext.datefontsize.String, Valid: true},
        datefontcolor: {String: this.selectcontext.datefontcolor.String, Valid: true},
        author: {String: this.selectcontext.author.String, Valid: true},
        authorfontname: {String: this.selectcontext.authorfontname.String, Valid: true},
        authorfontsize: {String: this.selectcontext.authorfontsize.String, Valid: true},
        authorfontcolor: {String: this.selectcontext.authorfontcolor.String, Valid: true},
        title: {String: this.s_title, Valid: true},
        titlefontname: {String: this.selectcontext.titlefontname.String, Valid: true},
        titlefontsize: {String: this.selectcontext.titlefontsize.String, Valid: true},
        titlefontcolor: {String: this.selectcontext.titlefontcolor.String, Valid: true},
        subtitle: {String: this.selectcontext.subtitle.String, Valid: true},
        subtitlefontname: {String: this.selectcontext.subtitlefontname.String, Valid: true},
        subtitlefontcolor: {String: this.selectcontext.subtitlefontcolor.String, Valid: true},
        link: {String: this.s_url, Valid: true},
        cusid: parseInt(19)
      }
      console.log(updata)
      that.$http({
        url: 'https://api.sqnetsoft.cn/website/aaumc',
        method: 'post',
        data: updata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '已更新完毕'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    addbindpagecontext () {
      console.log(this.pageinfo + 1)
      if (this.resourcename === '0') {
        this.resourcename = '1'
      }
      console.log(this.resourcename + 3)
      console.log(this.rowinfo)
      console.log(this.resourcename)
      console.log(that.selectsubdata)
      var udatas = []
      for (var index in that.selectsubdata) {
        var sdata = that.selectsubdata[index]
        var updata = {
          pageid: parseInt(this.pageinfo + 1),
          modelid: parseInt(parseInt(this.resourcename) + 3),
          rowindex: parseInt(this.rowinfo),
          colindex: parseInt(this.resourcename),
          resourcetype: parseInt(sdata.rtypeid),
          resourceid: parseInt(sdata.id.Int64),
          resourcename: {String: '', Valid: true},
          resourcecontext: {String: '', Valid: true},
          curdate: {String: '', Valid: true},
          datefontname: {String: '', Valid: true},
          datefontsize: {String: '', Valid: true},
          datefontcolor: {String: '', Valid: true},
          author: {String: '', Valid: true},
          authorfontname: {String: '', Valid: true},
          authorfontsize: {String: '', Valid: true},
          authorfontcolor: {String: '', Valid: true},
          title: {String: '', Valid: true},
          titlefontname: {String: '', Valid: true},
          titlefontsize: {String: '', Valid: true},
          titlefontcolor: {String: '', Valid: true},
          subtitle: {String: '', Valid: true},
          subtitlefontname: {String: '', Valid: true},
          subtitlefontcolor: {String: '', Valid: true},
          link: {String: '', Valid: true},
          cusid: parseInt(19)
        }
        udatas.push(updata)
      }
      console.log(udatas)
      that.$http({
        url: 'https://api.sqnetsoft.cn/website/paaumc',
        method: 'post',
        data: udatas,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '已填充路径内容完毕'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    addnewzt () {
      console.log('增加新子专题')
      this.ifeditzt = false
      this.ifhidden = true
      this.dialogsubztVisible = true
      switch (this.pageinfo) {
        case 2: {
          this.addsubzttitle = '添加新艺人作品'
          break
        }
        case 4: {
          this.addsubzttitle = '添加新创作作品'
          break
        }
        case 6: {
          this.addsubzttitle = '添加新商业作品'
          break
        }
      }
    },
    addsubzt (index, data) {
      this.ifhidden = false
      this.ifeditzt = false
      this.dialogsubztVisible = true
      switch (this.pageinfo) {
        case 2: {
          this.addsubzttitle = '添加新艺人作品'
          break
        }
        case 4: {
          this.addsubzttitle = '添加新创作作品'
          break
        }
        case 6: {
          this.addsubzttitle = '添加新商业作品'
          break
        }
      }
      this.selectcontext = data[index]
      this.addsubzttitle = '添加' + this.selectcontext.title.String + '的资料'
      var ifold = false
      var qstr, qstr1
      if (this.selectcontext.id.Int64 < 500) {
        var pagetmp = this.pageinfo + 1
        ifold = true
        qstr = 'pageid = ' + pagetmp + ' and modelid = 4' + ' and rowindex = ' + this.selectcontext.rowindex + ' and ossurl is not null'
        qstr1 = 'pageid = ' + pagetmp + ' and modelid = 5' + ' and rowindex = ' + this.selectcontext.rowindex + ' and ossurl is not null'
      } else {
        ifold = false
        qstr = 'rowindex = ' + this.selectcontext.id.Int64 + ' and modelid = 4'
        qstr1 = 'rowindex = ' + this.selectcontext.id.Int64 + ' and modelid = 5'
      }
      console.log(qstr)
      console.log(qstr1)
      that.$http({
        url: 'https://api.sqnetsoft.cn/website/qmc',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.pageimgdata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })

      that.$http({
        url: 'https://api.sqnetsoft.cn/website/qmc',
        method: 'post',
        data: {
          whereinfo: {String: qstr1, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.pagemoviedata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })

      console.log('更新原有链接')
      if (ifold) {
      } else {
        var pagetmp1 = this.pageinfo + 1
        var linktmp = 'http://www.jingshijue.cn/plate/subindex.html?pageid=' + pagetmp1 + '&rowindex=' + this.selectcontext.id.Int64
        var addzt = {
          id: {Int64: this.selectcontext.id.Int64, Valid: true},
          pageid: parseInt(this.pageinfo),
          modelid: parseInt(3),
          rowindex: parseInt(0),
          colindex: parseInt(0),
          resourcetype: parseInt(4),
          resourceid: parseInt(0),
          resourceoss: {String: this.selectcontext.resourceoss.String, Valid: true},
          title: {String: this.selectcontext.title.String, Valid: true},
          link: {String: linktmp, Valid: true},
          cusid: parseInt(this.khid)
        }
        that.$http({
          url: 'https://api.sqnetsoft.cn/website/aaumc',
          method: 'post',
          data: addzt,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.success) {
              var qstr = 'pageid = ' + that.pageinfo + ' and modelid = 3'
              that.$http({
                url: 'https://api.sqnetsoft.cn/website/qmc',
                method: 'post',
                data: {
                  whereinfo: {String: qstr, Valid: true}
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  if (res.data.success) {
                    console.log(JSON.parse(res.data.data))
                    that.pagecontextdata = JSON.parse(res.data.data)
                  }
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    },
    save_ztcontext () {
      console.log('先保存专题，再补充信息')
      var addzt
      if (this.ifeditzt) {
        addzt = {
          id: {Int64: this.selectcontext.id.Int64, Valid: true},
          pageid: parseInt(this.pageinfo),
          modelid: parseInt(3),
          rowindex: parseInt(0),
          colindex: parseInt(0),
          resourcetype: parseInt(4),
          resourceid: parseInt(0),
          resourceoss: {String: this.ztimg, Valid: true},
          title: {String: this.zttitle, Valid: true},
          link: {String: this.selectcontext.link.String, Valid: true},
          cusid: parseInt(this.khid)
        }
      } else {
        addzt = {
          pageid: parseInt(this.pageinfo),
          modelid: parseInt(3),
          rowindex: parseInt(0),
          colindex: parseInt(0),
          resourcetype: parseInt(4),
          resourceid: parseInt(0),
          resourceoss: {String: this.ztimg, Valid: true},
          title: {String: this.zttitle, Valid: true},
          link: {String: '', Valid: true},
          cusid: parseInt(this.khid)
        }
      }
      console.log(addzt)
      that.$http({
        url: 'https://api.sqnetsoft.cn/website/aaumc',
        method: 'post',
        data: addzt,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            that.dialogsubztVisible = false
            var qstr = 'pageid = ' + that.pageinfo + ' and modelid = 3'
            that.$http({
              url: 'https://api.sqnetsoft.cn/website/qmc',
              method: 'post',
              data: {
                whereinfo: {String: qstr, Valid: true}
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  console.log(JSON.parse(res.data.data))
                  that.pagecontextdata = JSON.parse(res.data.data)
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    addztimg () {
      var addzt = {
        pageid: parseInt(this.pageinfo),
        modelid: parseInt(4),
        rowindex: parseInt(this.selectcontext.id.Int64),
        colindex: parseInt(0),
        resourcetype: parseInt(4),
        resourceid: parseInt(0),
        resourceoss: {String: this.ztimg, Valid: true},
        title: {String: this.zttitle, Valid: true},
        link: {String: '', Valid: true},
        cusid: parseInt(this.khid)
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/website/aaumc',
        method: 'post',
        data: addzt,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            var qstr
            var pagetmp = that.pageinfo + 1
            if (that.selectcontext.ossurl.Valid) {
              qstr = 'pageid = ' + pagetmp + ' and modelid = 4' + ' and rowindex = ' + that.selectcontext.rowindex + ' and ossurl is not null'
            } else {
              qstr = 'rowindex = ' + that.selectcontext.id.Int64 + ' and modelid = 4'
            }
            console.log(qstr)
            that.$http({
              url: 'https://api.sqnetsoft.cn/website/qmc',
              method: 'post',
              data: {
                whereinfo: {String: qstr, Valid: true}
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  console.log(JSON.parse(res.data.data))
                  that.pageimgdata = JSON.parse(res.data.data)
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    addztvideo () {
      var addzt = {
        pageid: parseInt(this.pageinfo),
        modelid: parseInt(5),
        rowindex: parseInt(this.selectcontext.id.Int64),
        colindex: parseInt(1),
        resourcetype: parseInt(2),
        resourceid: parseInt(0),
        resourceoss: {String: this.ztimg, Valid: true},
        title: {String: this.zttitle, Valid: true},
        link: {String: '', Valid: true},
        cusid: parseInt(this.khid)
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/website/aaumc',
        method: 'post',
        data: addzt,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            var qstr
            if (that.selectcontext.ossurl.Valid) {
              var pagetmp = that.pageinfo + 1
              qstr = 'pageid = ' + pagetmp + ' and modelid = 5' + ' and rowindex = ' + that.selectcontext.rowindex + ' and ossurl is not null'
            } else {
              qstr = 'rowindex = ' + that.selectcontext.id.Int64 + ' and modelid = 5'
            }
            that.$http({
              url: 'https://api.sqnetsoft.cn/website/qmc',
              method: 'post',
              data: {
                whereinfo: {String: qstr, Valid: true}
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  console.log(JSON.parse(res.data.data))
                  that.pagemoviedata = JSON.parse(res.data.data)
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    addztvideoimg () {
      var addzt = {
        pageid: parseInt(this.pageinfo),
        modelid: parseInt(5),
        rowindex: parseInt(this.selectcontext.id.Int64),
        colindex: parseInt(2),
        resourcetype: parseInt(1),
        resourceid: parseInt(0),
        resourceoss: {String: this.ztimg, Valid: true},
        title: {String: this.zttitle, Valid: true},
        link: {String: '', Valid: true},
        cusid: parseInt(this.khid)
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/website/aaumc',
        method: 'post',
        data: addzt,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            var qstr
            if (that.selectcontext.ossurl.Valid) {
              var pagetmp = this.pageinfo + 1
              qstr = 'pageid = ' + pagetmp + ' and modelid = 5' + ' and rowindex = ' + that.selectcontext.rowindex + ' and ossurl is not null'
            } else {
              qstr = 'rowindex = ' + that.selectcontext.id.Int64 + ' and modelid = 5'
            }
            that.$http({
              url: 'https://api.sqnetsoft.cn/website/qmc',
              method: 'post',
              data: {
                whereinfo: {String: qstr, Valid: true}
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  console.log(JSON.parse(res.data.data))
                  that.pagemoviedata = JSON.parse(res.data.data)
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    removezt (index, data) {
      var selectdata = data[index]
      var dataindex = data.findIndex(d => d.id.Int64 === selectdata.id.Int64)
      // 移除该条数据
      data.splice(dataindex, 1)
      that.$http({
        url: 'https://api.sqnetsoft.cn/website/dmc',
        method: 'post',
        data: {
          whereinfo: {'String': 'id=' + selectdata.id.Int64, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    removemovie (index, data) {
      var selectdata = data[index]
      var dataindex = data.findIndex(d => d.id.Int64 === selectdata.id.Int64)
      // 移除该条数据
      data.splice(dataindex, 1)
      that.$http({
        url: 'https://api.sqnetsoft.cn/website/dmc',
        method: 'post',
        data: {
          whereinfo: {'String': 'id=' + selectdata.id.Int64, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    removeimg (index, data) {
      var selectdata = data[index]
      var dataindex = data.findIndex(d => d.id.Int64 === selectdata.id.Int64)
      // 移除该条数据
      data.splice(dataindex, 1)
      that.$http({
        url: 'https://api.sqnetsoft.cn/website/dmc',
        method: 'post',
        data: {
          whereinfo: {'String': 'id=' + selectdata.id.Int64, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    randomString (num) {
      let chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
      let res = ''
      for (let i = 0; i < num; i++) {
        var id = Math.ceil(Math.random() * 35)
        res += chars[id]
      }
      return res
    },

    /**
     * 创建oss客户端对象
     * @returns {*}
     */
    createOssClient () {
      return new Promise((resolve, reject) => {
        let client = new OSS({
          region: 'oss-cn-beijing',
          accessKeyId: 'LTAIK44bzZpLz0As',
          accessKeySecret: 'pWSiczyGrBXhnXIJ7Crj8GxNkkEzM0',
          bucket: 'wyzb1'
        })
        resolve(client)
      })
    },
    /**
     * @description [fnUploadRequest 覆盖默认的上传行为，实现自定义上传]
     * @author   yangxiaoshuo
     * @param    {object}   option [上传选项]
     * @return   {null}   [没有返回]
     */
    async fnUploadRequest (option) {
      var that = this
      let file = option.file
      const self = this
      return new Promise((resolve, reject) => {
        let date = Utils.dateFormat(new Date(), 'yyyyMMdd') // 当前时间
        console.log(date)
        let dateTime = Utils.dateFormat(new Date(), 'yyyyMMddhhmmss') // 当前时间
        let randomStr = self.randomString(4)//  4位随机字符串
        let extensionName = file.name.substr(file.name.indexOf('.')) // 文件扩展名
        console.log(dateTime)
        console.log(randomStr)
        console.log(extensionName)
        let fileName = that.selectpath + file.name // 文件名字（相对于根目录的路径 + 文件名）
        // 执行上传
        self.createOssClient().then(client => {
          // 异步上传,返回数据
          resolve({
            fileName: file.name,
            fileUrl: fileName
          })
          // 上传处理
          // 分片上传文件
          client.multipartUpload(fileName, file, {
            progress: function (p) {
              let e = {}
              e.percent = Math.floor(p * 100)
              // console.log('Progress: ' + p)
              option.onProgress(e)
              that.uppercent = e.percent
              console.log(e.percent)
            }
          }).then((val) => {
            if (val.res.statusCode === 200) {
              option.onSuccess(val)
              return val
            } else {
              option.onError('上传失败')
            }
          }, err => {
            option.onError('上传失败')
            reject(err)
          })
        }).catch(errinfo => {
        })
      })
    },
    /**
     * @description [fnUploadSuccess 文件上传成功的函数]
     * @author   shanshuizinong
     * @return   {null}  [没有返回]
     */
    async fnUploadSuccess (file) {
      console.log(file)
      console.log(this.uppath)
      // TODO
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>



// WEBPACK FOOTER //
// src/components/website/PageContext.vue